import { ILocationResponse } from "@wingspanhq/users";
import { WSQueryConfig } from "@ws-react-query";
import { usersService } from "../services/users";
import { WSServiceError } from "../utils/serviceHelper";
import { useWSQuery } from "./helpers";

export const QUERY_USER_LOCATION = "QUERY_USER_LOCATION";

export const useQueryUserLocation = (
  queryConfig?: WSQueryConfig<ILocationResponse, WSServiceError>
) =>
  useWSQuery(
    QUERY_USER_LOCATION,
    async () => await usersService.user.location.get(),
    {
      ...queryConfig
    }
  );
